module.exports = __webpack_public_path__ + "img/14_30.650c278e.png";